import AppLayout from "../layout/AppLayout";
import { Form, Spinner } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { useAlert } from "react-alert";
import { FaTrashAlt, FaCheck, FaSearch, FaFileExport, FaFileImport, FaSave, FaPlus, FaChevronLeft, FaChevronRight, FaTimes, FaDatabase, FaChevronDown } from "react-icons/fa";
import Cookies from "js-cookie";
import * as XLSX from 'xlsx';

import regenerateToken from "../regenerateToken";
import axios from "axios";
import Loader from "../loader/loader";
import './parameterMapping.css';
import { buildRequestConfig } from '../../utils/apiHelper';
import { isAdmin as checkAdmin } from '../../utils/authUtils';
import ngTestNames from '../../assets/ngTestNames';

// Don't Delete this since these are tests of our standard database
const dummyTests = ngTestNames;
// Profile mapped array
const existingProfiles = [
  "Liver Profile",
  "Allergy Panel",
  "Thyroid Profile",
  "Anemia Studies",
  "Kidney Profile",
  "Electrolyte Profile",
  "Diabetes Monitoring",
  "Urinalysis",
  "Blood Group",
  "Blood Clotting",
  "Vitamin Profile",
  "Arthritis Screening",
  "Blood Counts",
  "Lipid Profile",
  "Prothrombin Time",
  "Hormones",
  "Semen Culture and Sensitivity",
  "Cancer Profile",
  "Viral Infections",
  "Infectious Diseases",
  "Hepatitis",
  "STD Profile",
  "Bacterial Infections",
  "Stool Analysis",
  "Semen Analysis",
  "Immunity",
  "Cardiac Profile",
  "Autoimmune Disorders",
  "Tumour Marker Test",
  "Pancreas",
  "Hemoglobin Electrophoresis",
  "Inflammation",
  "Toxic elements",
  "BMI & BP",
  "COVID",
  "Blood Disorder",
  "Bone Health",
  "Heart Assure",
  "Hypertension",
  "Malaria Profile",
  "Mineral Profile",
  "Neurological Disorders",
  "Pregnancy",
  "Fertility Profile",
  "Cockroach, German",
  "Cat",
  "Dog",
  "Horse",
  "Camel",
  "Penicillium Notatum",
  "Caldosporium Herbarium",
  "Aspergillus Fumigatus",
  "Candida Albicans",
  "Alternaria Alternata",
  "Protein Profile",
  "Radiology",
  "Arterial Blood Gas Analysis",
  "Hair Loss",
  "Peripheral Blood Film",
  "Dengue Profile",
  "Peripheral Blood Smear",
  "COVID ANTIBODY",
  "Male Cancer Profile",
];


/* ------------------------------------------------------------------ */
/*  S3 URL for the NG Standard Test List XLSX                         */
/* ------------------------------------------------------------------ */
const NG_TEST_LIST_S3_URL =
  "https://niroggyan.s3.ap-south-1.amazonaws.com/NG_Test_list_WITH_ID_SOURCE+(2).xlsx";



const Mapping = () => {

  const countPerPage = 10; // For Pagination Purpose.
  const alert = useAlert();
  const [parameterList, setParameterList] = useState(dummyTests.sort());
  const [filteredTests, setFilteredTests] = useState(dummyTests);
  const [paginatedData, setPaginatedData] = useState(
    dummyTests.slice(0, countPerPage)
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [mappedTests, setMappedTests] = useState({});
  const [impotExcelData, setImpotExcelData] = useState({});
  const [mappingQue, setMappingQue] = useState({});
  const [saveOption, setSaveOption] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateLoader, setUpdateLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [filterMode, setFilterMode] = useState("all"); // 'all', 'mapped', 'unmapped'

  // States for Add New Parameter feature
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [newParameterName, setNewParameterName] = useState("");
  const [newParameterID, setNewParameterID] = useState("");
  const [newParameterProfile, setNewParameterProfile] = useState("");

  // States for Profile Mapping
  const [profileList, setProfileList] = useState({});
  const [profileSaveNeeded, setProfileSaveNeeded] = useState(false);
  const [openProfileDropdown, setOpenProfileDropdown] = useState(null); // tracks which test's dropdown is open
  const [profileSearchText, setProfileSearchText] = useState("");
  const profileDropdownRef = useRef(null);

  // console.log('mappedTests', mappedTests);

  const getExistingMapping = async () => {
    // ── ADMIN PATH: use admin token + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({
        method: "GET",
        url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/parameter",
      }));
    }
    // ── CLIENT PATH (unchanged) ──────────────────────────────────────────
    const idToken = Cookies.get("idToken");
    const existingStateConfiguration = {
      headers: {
        authorization: idToken,
      },
      method: "GET",
      url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/parameter",
      validateStatus: function (status) {
        return status >= 200 && status <= 401;
      },
    };
    const existingStateConfigurationResponse = await axios(
      existingStateConfiguration
    );
    console.log(
      "existingStateConfigurationResponse",
      existingStateConfigurationResponse
    );
    return existingStateConfigurationResponse;
  };

  const getExistingProfileMapping = async () => {
    // ── ADMIN PATH: use admin token + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({
        method: "GET",
        url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/profile",
      }));
    }
    // ── CLIENT PATH (unchanged) ──────────────────────────────────────────
    const idToken = Cookies.get("idToken");
    const existingMappingConfig = {
      headers: {
        authorization: idToken,
      },
      url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/profile",
      method: "GET",
      validateStatus: function (status) {
        return status >= 200 && status <= 401;
      },
    };
    const existingProfileMappingResponse = await axios(existingMappingConfig);
    return existingProfileMappingResponse;
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonArray = XLSX.utils.sheet_to_json(worksheet);

        console.log(jsonArray);


        // Convert the array of objects back into your state's format { key: value }
        const finalObject = jsonArray.reduce((acc, row) => {
          const originalName = row["NG Standard Name"];
          const mappedName = row["Test Name"];

          if (originalName && mappedName) {
            acc[originalName] = mappedName;
          }
          return acc;
        }, {});

        // ✅ Call your function with the final, processed object
        showingExistingMappedTests({ data: { data: { idMapping: finalObject } } });

      } catch (error) {
        console.error("Error processing Excel file:", error);
        alert.error("Failed to read the Excel file. Please ensure it's in the correct format.");
      }
    };
    reader.readAsArrayBuffer(file);

    e.target.value = null;
  };


  const handleDownloadExcel = () => {
    const dataForExcel = Object.keys(impotExcelData).map(key => ({
      "Test Name": impotExcelData[key],
      "NG Standard Name": key
    }));

    const ws = XLSX.utils.json_to_sheet(dataForExcel);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "MappedTests");

    XLSX.writeFile(wb, "MappedTests.xlsx");
  };

  useEffect(() => {
    (async function RetrieveExistingColorConfiguration() {
      setLoading(true);

      const fetchBoth = async () => {
        const paramRes = await getExistingMapping();
        const profRes = await getExistingProfileMapping();
        return { paramRes, profRes };
      };

      try {
        let { paramRes, profRes } = await fetchBoth();

        if (paramRes.status === 401 || profRes.status === 401) {
          await regenerateToken();
          const retry = await fetchBoth();
          paramRes = retry.paramRes;
          profRes = retry.profRes;
        }

        if (paramRes.data?.isSuccess) {
          showingExistingMappedTests(paramRes);
          setImpotExcelData(paramRes?.data?.data?.idMapping || {});
          console.log("updated State Configuration at load");
        }

        if (profRes.data?.isSuccess) {
          const mapping = profRes.data?.data?.profileMapping || {};
          setProfileList(mapping);
        }
      } catch (error) {
        console.error("Error fetching parameter mapping Configuration:", error);
        alert.error("Error loading mapping configurations. Please refresh the page.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // Warn user about unsaved changes
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (saveOption) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [saveOption]);

  // Close profile dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(e.target)) {
        setOpenProfileDropdown(null);
        setProfileSearchText("");
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // logic for showing the existing mapped
  // UPDATED: Now includes ALL parameters from API, not just those in dummyTests
  const showingExistingMappedTests = (response) => {
    const mappedTestsResult = {};
    const idMapping = response.data.data.idMapping;
    const existingMappingKeys = Object.keys(idMapping);

    // Collect all unique parameter names from the API response
    const allParameterNamesFromAPI = [...new Set(Object.values(idMapping))];

    // Build the mapped tests object from ALL API data
    existingMappingKeys.forEach((id) => {
      const testName = idMapping[id];
      if (mappedTestsResult[testName]) {
        mappedTestsResult[testName] = [...mappedTestsResult[testName], id];
      } else {
        mappedTestsResult[testName] = [id];
      }
    });

    // Find parameters from API that are NOT in the current parameterList and add them
    setParameterList((prevList) => {
      const newParams = allParameterNamesFromAPI.filter(
        (name) => !prevList.some((p) => p.toLowerCase() === name.toLowerCase())
      );
      if (newParams.length > 0) {
        const updatedList = [...prevList, ...newParams].sort();
        // Also update filtered and paginated data
        setFilteredTests(updatedList);
        setPaginatedData(updatedList.slice(0, countPerPage));
        setCurrentPage(1);
        return updatedList;
      }
      return prevList;
    });

    setMappedTests(mappedTestsResult);
  };

  // UPDATED: Search by parameter name OR mapped ID
  const filteringTests = (search) => {
    setSearch(search);
    const searchLower = search.toLowerCase();
    const tests = parameterList.filter((each) => {
      // Match by parameter name
      if (each.toLowerCase().includes(searchLower)) return true;
      // Match by mapped ID(s)
      if (mappedTests[each]) {
        return mappedTests[each].some((id) =>
          id.toLowerCase().includes(searchLower)
        );
      }
      // Match by pending mapping queue ID(s)
      if (mappingQue[each]) {
        return mappingQue[each].some((id) =>
          id.toLowerCase().includes(searchLower)
        );
      }
      return false;
    });
    setFilteredTests(tests);
    setPaginatedData(tests.slice(0, countPerPage));
    setCurrentPage(1);
    setFilterMode("all");
  };

  const handlingMapping = (mappedTest, requiredID) => {
    setFilterMode("all");
    if (requiredID.includes("$")) {
      setMappingQue((prevState) => ({
        ...prevState,
        [mappedTest]: requiredID.split("$"),
      }));
    } else {
      // setMappingQue(prevState => ({
      //   ...prevState,
      //   [mappedTest]: [requiredID],
      // }));
      setMappingQue((prevState) => {
        if (requiredID !== "") {
          return { ...prevState, [mappedTest]: [requiredID] };
        } else {
          return { ...prevState, [mappedTest]: [""] };
        }
      });
    }
  };

  const confirmMapping = (test) => {
    setMappedTests((prevMapped) => ({ ...prevMapped, ...mappingQue }));
    setMappingQue({});
    setSaveOption(true);
  };

  const retrieveValue = (test) => {
    if (mappedTests[test]) {
      return mappedTests[test].join("$");
    }
  };

  // Get current input value - checks mappingQue first (pending changes), then mappedTests (confirmed)
  const getCurrentInputValue = (test) => {
    // If there's a pending change in mappingQue, use that
    if (mappingQue[test]) {
      return mappingQue[test].join("$");
    }
    // Otherwise, use the confirmed mapping from mappedTests
    if (mappedTests[test]) {
      return mappedTests[test].join("$");
    }
    // If neither exists, return empty string
    return "";
  };



  const handleConfirmation = async () => {
    const mergedMappedTests = { ...mappedTests, ...mappingQue };

    // Remove entries whose IDs are all empty (cleared mappings)
    Object.keys(mergedMappedTests).forEach((key) => {
      const ids = mergedMappedTests[key];
      if (!ids || (Array.isArray(ids) && ids.every((v) => v === ""))) {
        delete mergedMappedTests[key];
      }
    });

    const idEnteredTillTime = Object.values(mergedMappedTests);
    const repeatitionOfId = {};
    idEnteredTillTime.forEach((eachIDArray) => {
      eachIDArray.forEach((eachId) => {
        if (eachId in repeatitionOfId) {
          repeatitionOfId[eachId] += 1;
        } else {
          repeatitionOfId[eachId] = 1;
        }
      });
    });

    // checking for deuplicate ID's
    const repeatedID = [];
    Object.keys(repeatitionOfId).forEach((eachId) => {
      if (repeatitionOfId[eachId] > 1) {
        repeatedID.push(eachId);
      }
    });

    if (repeatedID.length > 0) {
      return alert.error(
        <span style={{ textTransform: "none" }}>
          Test {repeatedID.length >= 2 ? "Id's " : "Id "}
          {repeatedID.join(", ")} {repeatedID.length >= 2 ? "have " : "has "}{" "}
          been repeated. Please Enter Unique ID.
        </span>
      );
    } else {
      const finalMappedTests = {};
      const testsKeys = Object.keys(mergedMappedTests);
      testsKeys.forEach((eachTest) => {
        mergedMappedTests[eachTest].forEach((eachID) => {
          finalMappedTests[eachID] = eachTest;
        });
      });

      try {
        setUpdateLoader(true);
        let updatingMapping;
        // ── ADMIN PATH: use admin token + inject clientId if a client is selected
        if (checkAdmin()) {
          updatingMapping = await axios(buildRequestConfig({
            method: "POST",
            url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/parameter",
            data: finalMappedTests,
          }));
          if (updatingMapping.status === 401) {
            await regenerateToken();
            updatingMapping = await axios(buildRequestConfig({
              method: "POST",
              url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/parameter",
              data: finalMappedTests,
            }));
          }
        } else {
          // ── CLIENT PATH (unchanged) ──────────────────────────────────────────
          const idToken = Cookies.get("idToken");
          const mappingConfiguration = {
            url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/parameter",
            headers: {
              authorization: idToken,
            },
            method: "POST",
            validateStatus: function (status) {
              return status >= 200 && status <= 401;
            },
            data: finalMappedTests,
          };
          updatingMapping = await axios(mappingConfiguration);
          if (updatingMapping.status === 401) {
            console.log("Regenerating ID Token");
            await regenerateToken();
            mappingConfiguration.headers.authorization = Cookies.get("idToken");
            updatingMapping = await axios(mappingConfiguration);
          }
        }

        console.log("updating Mapping Parameters Response\n", updatingMapping);
        const mapSuccess = updatingMapping.data?.isSuccess;

        if (mapSuccess) {
          setMappedTests(mergedMappedTests);
          setMappingQue({});
          setImpotExcelData(finalMappedTests);

          // Also save profile mapping if profiles were changed
          if (profileSaveNeeded) {
            try {
              let profResponse = await saveProfileMapping();
              if (profResponse.status === 401) {
                await regenerateToken();
                profResponse = await saveProfileMapping();
              }
              if (profResponse.data?.isSuccess) {
                setProfileSaveNeeded(false);
              }
            } catch (profErr) {
              console.error("Error saving profile mapping:", profErr);
              // Don't block the overall success — parameter mapping was saved
            }
          }

          setSaveOption(false);
          alert.success(
            <span style={{ textTransform: "none" }}>
              Parameter mappings saved successfully!
            </span>
          );
        } else {
          alert.error("Failed to save parameter mappings.");
        }
      } catch (e) {
        console.log(e.message);
        alert.error("Network Error: Failed to save mappings. Please check your connection.");
      } finally {
        setUpdateLoader(false);
      }
    }
  };

  const updatingPages = (p) => {
    const finalCount = p * countPerPage;
    const initialCount = finalCount - countPerPage;
    setPaginatedData(filteredTests.slice(initialCount, finalCount));
    setCurrentPage(p);
  };

  const clearingMappedId = (test) => {
    // Remove from mappedTests
    setMappedTests((prevMapped) => {
      const newMapped = { ...prevMapped };
      delete newMapped[test];
      return newMapped;
    });

    // Also clear any pending changes in mappingQue
    setMappingQue((prevQue) => {
      const newQue = { ...prevQue };
      delete newQue[test];
      return newQue;
    });

    setSaveOption(true);
  };



  const showMapped = () => {
    setFilterMode("mapped");
    const searchLower = search.toLowerCase();
    const tests = parameterList.filter((each) => {
      if (each.toLowerCase().includes(searchLower)) return true;
      if (mappedTests[each]) {
        return mappedTests[each].some((id) => id.toLowerCase().includes(searchLower));
      }
      return false;
    });
    const MappedTests = tests.filter((each) => {
      if (Object.keys(mappedTests).includes(each)) {
        return true;
      } else {
        return false;
      }
    });
    setFilteredTests(MappedTests);
    setPaginatedData(MappedTests.slice(0, countPerPage));
    setCurrentPage(1);
  };

  const showUnmapped = () => {
    setFilterMode("unmapped");
    const searchLower = search.toLowerCase();
    const tests = parameterList.filter((each) => {
      if (each.toLowerCase().includes(searchLower)) return true;
      if (mappedTests[each]) {
        return mappedTests[each].some((id) => id.toLowerCase().includes(searchLower));
      }
      return false;
    });
    const UnmappedTests = tests.filter((each) => {
      if (Object.keys(mappedTests).includes(each)) {
        return false;
      } else {
        return true;
      }
    });
    setFilteredTests(UnmappedTests);
    setPaginatedData(UnmappedTests.slice(0, countPerPage));
    setCurrentPage(1);
  };

  const removeFilter = () => {
    setFilterMode("all");
    const searchLower = search.toLowerCase();
    const tests = parameterList.filter((each) => {
      if (each.toLowerCase().includes(searchLower)) return true;
      if (mappedTests[each]) {
        return mappedTests[each].some((id) => id.toLowerCase().includes(searchLower));
      }
      return false;
    });
    setFilteredTests(tests);
    setPaginatedData(tests.slice(0, countPerPage));
    setCurrentPage(1);
  };

  // Handler to auto-fill mappings by fetching the NG Test List from S3
  const handleUseNgTestIds = async () => {
    const existingCount = Object.keys(mappedTests).length;
    const confirmMsg = existingCount > 0
      ? `This will replace your current ${existingCount} mappings with the standard NG Test IDs fetched from the server. Continue?`
      : `This will load the standard NG Test ID mappings from the server. Continue?`;

    if (!window.confirm(confirmMsg)) return;

    try {
      setLoading(true);

      // Fetch the XLSX from S3 as a binary ArrayBuffer
      const response = await axios.get(NG_TEST_LIST_S3_URL, {
        responseType: "arraybuffer",
      });

      // Parse the workbook
      const workbook = XLSX.read(response.data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonArray = XLSX.utils.sheet_to_json(worksheet);

      if (!jsonArray || jsonArray.length === 0) {
        alert.error(<span style={{ textTransform: "none" }}>The NG Test list file appears to be empty.</span>);
        return;
      }

      // ── Auto-detect column names from the actual file ──────────────────
      const allCols = Object.keys(jsonArray[0]);
      console.log("NG Test list columns:", allCols);
      console.log("NG Test list first row sample:", jsonArray[0]);

      // ID column: the column whose values look like NGPM codes (start with NGPM)
      const idCol = allCols.find((col) =>
        jsonArray.slice(0, 20).some((row) =>
          String(row[col] || "").trim().toUpperCase().startsWith("NGPM")
        )
      );

      // Name column: prefer a column header containing "name" or "standard"
      // but skip the idCol
      const nameCol = allCols.find((col) => {
        if (col === idCol) return false;
        const lower = col.toLowerCase();
        return lower.includes("name") || lower.includes("standard");
      }) ||
        // fallback: first column that isn't the idCol
        allCols.find((col) => col !== idCol);

      console.log(`Using ID column: "${idCol}" | Name column: "${nameCol}"`);

      if (!idCol || !nameCol) {
        alert.error(
          <span style={{ textTransform: "none" }}>
            Could not detect ID or Name columns in the NG Test list file.
            Please check the browser console for column details.
          </span>
        );
        return;
      }

      // Build { ngId → testName } map — same shape as idMapping from API
      const idMapping = jsonArray.reduce((acc, row) => {
        const ngId = String(row[idCol] || "").trim();
        const testName = String(row[nameCol] || "").trim();
        if (ngId && testName) {
          acc[ngId] = testName;
        }
        return acc;
      }, {});

      console.log(`Built idMapping with ${Object.keys(idMapping).length} entries`);

      if (Object.keys(idMapping).length === 0) {
        alert.error(
          <span style={{ textTransform: "none" }}>
            Could not read any entries from the NG Test list. Please check the
            browser console for column details.
          </span>
        );
        return;
      }

      // Feed through the same pipeline used by Import Excel & API fetch
      showingExistingMappedTests({ data: { data: { idMapping } } });
      setSaveOption(true);
      setMappingQue({});
      removeFilter();
      alert.success(
        <span style={{ textTransform: "none" }}>
          {Object.keys(idMapping).length} NG Test IDs loaded successfully! Review
          and click "Save All Changes" to publish.
        </span>
      );
    } catch (error) {
      console.error("Failed to fetch NG Test list from S3:", error);
      alert.error(
        <span style={{ textTransform: "none" }}>
          Failed to fetch the NG Test list. Please check your connection and try
          again.
        </span>
      );
    } finally {
      setLoading(false);
    }
  };


  // Handler to open the "Add New Parameter" form
  const handleOpenNewParameterForm = () => {
    setIsAddingNew(true);
    setNewParameterName("");
    setNewParameterID("");
    setNewParameterProfile("");
  };

  // Handler to cancel adding new parameter
  const handleCancelNewParameter = () => {
    setIsAddingNew(false);
    setNewParameterName("");
    setNewParameterID("");
    setNewParameterProfile("");
  };

  // Handler to add new parameter
  const handleAddNewParameter = () => {
    // Trim whitespace
    const trimmedName = newParameterName.trim();
    const trimmedID = newParameterID.trim();

    // Validation: Check if both fields are filled
    if (!trimmedName || !trimmedID) {
      return alert.error("Please fill in both Parameter Name and Test ID fields.");
    }

    // Validation: Check if parameter name already exists (case-insensitive)
    const parameterExists = parameterList.some(
      (param) => param.toLowerCase() === trimmedName.toLowerCase()
    );

    if (parameterExists) {
      return alert.error(
        <span style={{ textTransform: "none" }}>
          Parameter "{trimmedName}" already exists in the list.
        </span>
      );
    }

    // Validation: Check max length (100 characters)
    if (trimmedName.length > 100) {
      return alert.error("Parameter name is too long. Maximum 100 characters allowed.");
    }

    if (trimmedID.length > 100) {
      return alert.error("Test ID is too long. Maximum 100 characters allowed.");
    }

    // Add to parameter list and sort alphabetically
    const updatedParameterList = [...parameterList, trimmedName].sort();
    setParameterList(updatedParameterList);

    // Add to mapped tests & profiles immediately
    setMappedTests((prevMapped) => ({
      ...prevMapped,
      [trimmedName]: [trimmedID],
    }));

    // We let the profile be set from the form input (can be empty)
    setProfileList((prevProfile) => ({
      ...prevProfile,
      [trimmedName]: newParameterProfile.trim(),
    }));
    if (newParameterProfile.trim()) {
      setProfileSaveNeeded(true);
    }

    // Update filtered tests and pagination
    const updatedFilteredTests = updatedParameterList.filter((each) =>
      each.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredTests(updatedFilteredTests);
    setPaginatedData(updatedFilteredTests.slice(0, countPerPage));

    // Reset form and close
    setIsAddingNew(false);
    setNewParameterName("");
    setNewParameterID("");
    setNewParameterProfile("");

    // Enable save option
    setSaveOption(true);

    // Show success message
    alert.success(
      <span style={{ textTransform: "none" }}>
        Parameter "{trimmedName}" added successfully!
      </span>
    );

    // Clear any active filters to show the new parameter
    setFilterMode("all");
    setCurrentPage(1);
  };

  // Handler to update profile for a parameter (editable profile column)
  const handleProfileChange = (test, profile) => {
    setProfileList((prev) => ({ ...prev, [test]: profile }));
    setSaveOption(true);
    setProfileSaveNeeded(true);
  };

  // Save profile mapping to API
  const saveProfileMapping = async () => {
    if (checkAdmin()) {
      return await axios(buildRequestConfig({
        method: "POST",
        url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/profile",
        data: profileList,
      }));
    }
    const idToken = Cookies.get("idToken");
    const config = {
      headers: { authorization: idToken },
      url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/mapping/profile",
      method: "POST",
      validateStatus: function (status) { return status >= 200 && status <= 401; },
      data: JSON.stringify(profileList),
    };
    return await axios(config);
  };

  return (
    <AppLayout>
      {loading ? (
        <Loader />
      ) : (
        <div className="pm-container">
          {/* 1. Header with Actions */}
          <div className="pm-header">
            <div className="pm-title">
              <h2>Parameter & Profile Mapping</h2>
              <p>Map your internal parameter names to standard test IDs and health profiles.</p>
            </div>
            <div className="pm-header-actions">
              <button className="pm-btn pm-btn-outline" onClick={handleDownloadExcel}>
                <FaFileExport /> Export Excel
              </button>

              <label htmlFor="file-upload" className="pm-btn pm-btn-outline" style={{ marginBottom: 0 }}>
                <FaFileImport /> Import Excel
              </label>
              <input
                id="file-upload"
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />

              <button
                onClick={handleConfirmation}
                className="pm-btn pm-btn-primary"
                disabled={updateLoader}
              >
                {updateLoader ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <><FaSave /> Save All Changes</>
                )}
              </button>
              <button className="pm-btn pm-btn-add-new" onClick={handleOpenNewParameterForm}>
                <FaPlus /> Add Parameter
              </button>
            </div>
          </div>

          {/* 2. Controls: Search + Filters + Stats */}
          <div className="pm-controls">
            <div className="pm-search-wrapper">
              <FaSearch className="pm-search-icon" />
              <input
                className="pm-search-input"
                placeholder="Search by parameter name or mapped ID..."
                value={search}
                onChange={(event) => filteringTests(event.target.value)}
              />
            </div>
            <button className="pm-btn pm-btn-ng" onClick={handleUseNgTestIds}>
              <FaDatabase /> Use NG Test IDs
            </button>

            <div className="d-flex align-items-center gap-3">
              <div className="pm-filters">
                <div
                  className={`pm-filter-option ${filterMode === 'all' ? 'active' : ''}`}
                  onClick={removeFilter}
                  role="button"
                  tabIndex={0}
                  aria-pressed={filterMode === 'all'}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      removeFilter();
                    }
                  }}
                >
                  All Tests
                </div>
                <div
                  className={`pm-filter-option ${filterMode === 'mapped' ? 'active' : ''}`}
                  onClick={showMapped}
                  role="button"
                  tabIndex={0}
                  aria-pressed={filterMode === 'mapped'}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      showMapped();
                    }
                  }}
                >
                  Mapped
                </div>
                <div
                  className={`pm-filter-option ${filterMode === 'unmapped' ? 'active' : ''}`}
                  onClick={showUnmapped}
                  role="button"
                  tabIndex={0}
                  aria-pressed={filterMode === 'unmapped'}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      showUnmapped();
                    }
                  }}
                >
                  Unmapped
                </div>
              </div>

              <div className="pm-stats">
                Total Mapped: {Object.keys(mappedTests).length}
              </div>
            </div>
          </div>

          {/* 3. List Header & Grid */}
          <div className="pm-list-header">
            <div>Master Test Name</div>
            <div>Mapped ID / Name</div>
            <div>Assigned Profile</div>
            <div className="text-center">Action</div>
          </div>

          <div className="pm-list-container">
            {/* New Parameter Input Row */}
            {isAddingNew && (
              <div className="pm-row pm-row-new-parameter">
                <div className="pm-input-wrapper">
                  <input
                    className="pm-input"
                    placeholder="Enter new parameter name"
                    value={newParameterName}
                    onChange={(e) => setNewParameterName(e.target.value)}
                    autoFocus
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleAddNewParameter();
                      } else if (e.key === 'Escape') {
                        handleCancelNewParameter();
                      }
                    }}
                  />
                </div>
                <div className="pm-input-wrapper">
                  <input
                    className="pm-input"
                    placeholder="Enter corresponding Test ID"
                    value={newParameterID}
                    onChange={(e) => setNewParameterID(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleAddNewParameter();
                      } else if (e.key === 'Escape') {
                        handleCancelNewParameter();
                      }
                    }}
                  />
                </div>
                <div className="pm-select-wrapper mt-auto mb-auto pm-profile-dropdown-container" ref={openProfileDropdown === '__new__' ? profileDropdownRef : null}>
                    <div
                      className="pm-profile-trigger"
                      onClick={() => {
                        setOpenProfileDropdown(openProfileDropdown === '__new__' ? null : '__new__');
                        setProfileSearchText("");
                      }}
                    >
                      <span className={newParameterProfile ? "pm-profile-value" : "pm-profile-placeholder"}>
                        {newParameterProfile || "Select profile"}
                      </span>
                      <FaChevronDown size={10} className="pm-profile-chevron" />
                    </div>
                    {openProfileDropdown === '__new__' && (
                      <div className="pm-profile-dropdown">
                        <input
                          className="pm-profile-dropdown-search"
                          placeholder="Search or type new..."
                          value={profileSearchText}
                          onChange={(e) => setProfileSearchText(e.target.value)}
                          autoFocus
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && profileSearchText.trim()) {
                              setNewParameterProfile(profileSearchText.trim());
                              setOpenProfileDropdown(null);
                              setProfileSearchText("");
                            } else if (e.key === 'Escape') {
                              setOpenProfileDropdown(null);
                              setProfileSearchText("");
                            }
                          }}
                        />
                        <div className="pm-profile-dropdown-list">
                          {existingProfiles
                            .filter((p) => p.toLowerCase().includes(profileSearchText.toLowerCase()))
                            .map((eachProfile) => (
                              <div
                                key={`new-${eachProfile}`}
                                className={`pm-profile-dropdown-item ${newParameterProfile === eachProfile ? 'active' : ''}`}
                                onClick={() => {
                                  setNewParameterProfile(eachProfile);
                                  setOpenProfileDropdown(null);
                                  setProfileSearchText("");
                                }}
                              >
                                {eachProfile}
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                <div className="d-flex justify-content-center gap-2">
                  <button
                    className="pm-action-btn pm-btn-confirm"
                    title="Confirm and Add Parameter"
                    onClick={handleAddNewParameter}
                  >
                    <FaCheck size={14} />
                  </button>
                  <button
                    className="pm-action-btn pm-btn-cancel"
                    title="Cancel"
                    onClick={handleCancelNewParameter}
                  >
                    <FaTimes size={14} />
                  </button>
                </div>
              </div>
            )}

            {/* Existing Parameters */}
            {paginatedData.length !== 0 ? (
              paginatedData.map((test, index) => (
                <div className="pm-row" key={test}>
                  <div className="pm-test-name">{test}</div>
                  <div className="pm-input-wrapper">
                    <input
                      className="pm-input"
                      id={test}
                      key={`${test}-${currentPage}-id`} // Force re-render on page change
                      disabled={!!mappedTests[test]} // double bang to boolean
                      placeholder={mappedTests[test] ? "Mapped" : "Enter corresponding Test ID"}
                      value={getCurrentInputValue(test)}
                      onChange={(event) => {
                        handlingMapping(test, event.target.value);
                        setSaveOption(true);
                      }}
                    />
                  </div>
                  <div className="pm-select-wrapper mt-auto mb-auto pm-profile-dropdown-container" ref={openProfileDropdown === test ? profileDropdownRef : null}>
                    <div
                      className="pm-profile-trigger"
                      onClick={() => {
                        setOpenProfileDropdown(openProfileDropdown === test ? null : test);
                        setProfileSearchText("");
                      }}
                      title={profileList[test] || "Click to assign profile"}
                    >
                      <span className={profileList[test] ? "pm-profile-value" : "pm-profile-placeholder"}>
                        {profileList[test] || "Select profile"}
                      </span>
                      <FaChevronDown size={10} className="pm-profile-chevron" />
                    </div>
                    {openProfileDropdown === test && (
                      <div className="pm-profile-dropdown">
                        <input
                          className="pm-profile-dropdown-search"
                          placeholder="Search or type new..."
                          value={profileSearchText}
                          onChange={(e) => setProfileSearchText(e.target.value)}
                          autoFocus
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && profileSearchText.trim()) {
                              handleProfileChange(test, profileSearchText.trim());
                              setOpenProfileDropdown(null);
                              setProfileSearchText("");
                            } else if (e.key === 'Escape') {
                              setOpenProfileDropdown(null);
                              setProfileSearchText("");
                            }
                          }}
                        />
                        <div className="pm-profile-dropdown-list">
                          {existingProfiles
                            .filter((p) => p.toLowerCase().includes(profileSearchText.toLowerCase()))
                            .map((eachProfile) => (
                              <div
                                key={eachProfile}
                                className={`pm-profile-dropdown-item ${profileList[test] === eachProfile ? 'active' : ''}`}
                                onClick={() => {
                                  handleProfileChange(test, eachProfile);
                                  setOpenProfileDropdown(null);
                                  setProfileSearchText("");
                                }}
                              >
                                {eachProfile}
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="pm-action-column d-flex justify-content-center gap-2">
                    {/* Show Confirm/Add Button if there is something in the queue for this test */}
                    {(mappingQue[test] && mappingQue[test].join("") !== "") && (
                      <button
                        className="pm-action-btn pm-btn-add"
                        title="Confirm Changes"
                        onClick={() => confirmMapping(test)}
                      >
                        <FaCheck size={14} />
                      </button>
                    )}

                    {/* Delete mapping: Will strictly and securely delete the Parameter ID ONLY */}
                    {mappedTests[test] && (
                      <button
                        className="pm-action-btn pm-btn-remove"
                        title="Clear ID Mapping"
                        onClick={() => clearingMappedId(test)}
                      >
                        <FaTrashAlt size={14} />
                      </button>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="p-5 text-center text-muted">
                No parameters found matching your search.
              </div>
            )}
          </div>

          {/* 4. Pagination */}
          <Pagination
            onChange={(p) => updatingPages(p)}
            pageSize={countPerPage}
            total={filteredTests.length}
            current={currentPage}
            showTitle={false}
            itemRender={(current, type, element) => {
              if (type === 'prev') {
                return (
                  <span className="pm-pagination-icon">
                    <FaChevronLeft />
                  </span>
                );
              }
              if (type === 'next') {
                return (
                  <span className="pm-pagination-icon">
                    <FaChevronRight />
                  </span>
                );
              }
              return element;
            }}
          />

        </div>
      )}
    </AppLayout>
  );
};
export default Mapping;
